
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NextStepsModal',

  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    actionDisabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      steps: [
        {
          title: 'Create the configuration file',
          description:
            'Create a new file called <span class="font-mono text-vanilla-300">.deepsource.toml</span> in the root folder of the repository. Make sure you\'re on the default branch.'
        },
        {
          title: 'Commit to the default branch',
          description:
            'Paste the generated configuration in this file and commit it to the default branch.'
        },
        {
          title: 'Wait for the results',
          description:
            "The analysis should start automatically after the commit. Once the analysis is complete, you'll be able to view all the issues we've found in the repository."
        }
      ]
    }
  },

  methods: {
    close(): void {
      this.$emit('close')
    },

    triggerAction(): void {
      this.$emit('activate')
    }
  }
})
